import api from "@/services/api";

const _http = {
    getInfras(params) {
        return api.get("/infrastructure", { params });
    },
    getInfrasById(id) {
        return api.get(`/infrastructure/${id}`);
    },
    createInfras(data) {
        const isFormData = data instanceof FormData;
        return api.post("/infrastructure", data, {
            headers: isFormData ? { "Content-Type": "multipart/form-data" } : {},
            timeout: isFormData ? 60000 : 10000,
        });
    },
    updateInfras(id, data) {
        const isFormData = data instanceof FormData;
        return api.put(`/infrastructure/${id}`, data, {
            headers: isFormData ? { "Content-Type": "multipart/form-data" } : {},
            timeout: isFormData ? 60000 : 10000,
        });
    },
    getSignedUrl(key) {
        return api.get("/s3-signed-url", { params: { key } });
    },
};




export default {
  async getAll(params) {
    try {
      const res = await _http.getInfras(params);
      return {
        data: (res.data.data || []).map((item) => item),
        total: res.data.total || 0,
      };
    } catch (error) {
      console.error(error);
      return { data: [], total: 0 };
    }
  },

  async getById(id) {
    try {
      const res = await _http.getInfrasById(id);
      return res.data.data || {};
    } catch (error) {
      console.error(error);
      return null;
    }
  },

  async create(data) {
    const res = await _http.createInfras(data);
    return res.data;
  },

  async update(id, data) {
    const res = await _http.updateInfras(id, data);
    return res.data;
  },

  async getSignedUrl(key) {
    try {
      const res = await _http.getSignedUrl(key);
      return res.data;
    } catch (error) {
      console.error("Error getting signed url:", error);
      return null;
    }
  },
};

